import(/* webpackMode: "eager" */ "/actual-project/app/global-error.tsx")